export default __webpack_public_path__ + "static/media/2d2.f2ae7f4c.gif";